module.exports = __webpack_public_path__ + "static/media/bombaspabgp.34ba61d1.png";